import * as React from 'react';
import videojs from 'video.js';
import styled from 'styled-components';
import 'video.js/dist/video-js.min.css';
import { dataLayer } from '../App';

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const VideoPlaceholder = styled.div`
  position: relative;
  padding-top: 56.25%;
`;

const VideoContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const FakeVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
`;

class VideoPlayer extends React.Component {
  player = null;
  videoNode = null;

  constructor(props) {
    super(props);

    this.videoNode = React.createRef();
    this.fakeVideoNode = React.createRef();

    this.state = {
      error: false,
      playedSeconds: 0,
      duration: 0,
      ready: false,
      playing: false,
      init: false,
      played: 0
    }

  }

  componentDidMount() {
    const { videoUrl } = this.props;
  
    if (!!this.videoNode && !!this.videoNode.current) {
      this.player = videojs(
        this.videoNode.current,
        {
          aspectRatio: '16:9',
          controls: true,
          sources: [{
            src: videoUrl,
            type: 'video/mp4'
          }]
        },
        () => {
          this.player.on('ended', function() {
            dataLayer.push({ event: 'CodeHomeVideoEvent' });
          });
      });
    }
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  onPlay = () => {
    if (!!this.fakeVideoNode) {
      this.setState(prevState => ({ playing: !prevState.playing }));
      this.player.currentTime(this.fakeVideoNode.current.currentTime);
      this.player.play();
    }
  }
  
  render() {
    const { videoUrl, fallbackImage, className, coverId } = this.props;
    const { playing } = this.state;

    return (
      <div className={className}>
        {
          !!videoUrl && videoUrl.indexOf('.mp4') !== -1 ? 
          <VideoWrapper>
            <VideoPlaceholder>
              <VideoContent>
                <div data-vjs-player>
                  <video
                    className="video-js"
                    playsInline
                    ref={this.videoNode}
                  />
                </div>
              </VideoContent>
              {!playing && <FakeVideo id={coverId} ref={this.fakeVideoNode} playsInline autoPlay muted src={videoUrl} onClick={this.onPlay} />}
            </VideoPlaceholder>
          </VideoWrapper> :
          <>
            <img className="mobile" src={fallbackImage.mobile} alt="" width="100%" />
            <img className="desktop" src={fallbackImage.desktop} alt="" width="100%" />
          </>
        }
      </div>
    );
  }
}

export default VideoPlayer;